'use strict'

// import { IeModal } from './lib/IeModal'
// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { KvParallax } from './lib/KvParallax'
import { KvAnimation } from './lib/KvAnimation'
import { EventSlider } from './lib/EventSlider'
import { FooterAnimation } from './lib/FooterAnimation'
import { MoveBoat } from './lib/MoveBoat'
import { Modal } from './lib/Modal'
import { SmoothScroll } from './lib/SmoothScroll'
import { TextSplit } from './lib/TextSplit'
import { ScrollSp } from './lib/ScrollSp'
import { GetPost } from './lib/GetPost'

// new IeModal('サイト名', 'http://hoge.com')
// new CookiePolicy('optout')
export const smoothScroll = new SmoothScroll()
new Svg()
new TelGrant()
new Smooth()
new ScrollStatus()
new ScrollAnimation()
new KvParallax()
new KvAnimation()
new Modal()
new Drawer()
// new EventSlider()
new FooterAnimation()
new MoveBoat()
new TextSplit()
new ScrollSp()
new GetPost()
